import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  useBaseAsync,
} from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ref } from 'vue';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props, { expose: __expose }) {

const visible = ref(false);
const loading = ref(false);
const tableRef = ref<InstanceType<typeof JuouProTable>>();
const storeId = ref<number>(0);
const storeName = ref('');
const currentDateRange = ref<string[]>([]);

const conditionsInitValue = {
  dateRange: [
    dayjs()
      .subtract(7, 'day')
      .format('YYYY-MM-DD'),
    dayjs()
      .format('YYYY-MM-DD'),
  ],
};

const columns = ref<JuouProTableColumn[]>([
  {
    name: 'dateRange',
    label: '时间范围',
    type: 'datepick',
    pickType: 'daterange',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期',
    isCondition: true,
    hideTable: true,
  },
  {
    name: 'storeName',
    label: '店铺名称',
    type: 'string',
  },
  {
    name: 'syncTime',
    label: '统计日期',
    type: 'string',
  },
  {
    name: 'openCount',
    label: '开门次数',
    type: 'numberStr',
    width: 80,
  },
  {
    name: 'openPeople',
    label: '开门人数',
    type: 'numberStr',
    width: 80,
  },
]);

const handleExport = async() => {
  const [start, end] = currentDateRange.value || [];
  const res = await useApi().storeStatisticsApi.exportStoreStatisticsstoreStatistics({
    conditions: {
      storeId: storeId.value,
    },
    start: start ? dayjs(start)
      .format('YYYY-MM-DD') : undefined,
    end: end ? dayjs(end)
      .format('YYYY-MM-DD') : undefined,
  });
  if (res.data.data?.file) {
    window.open(useApi().baseUrl + res.data.data.file, '_blank');
  }
};

const topOperates = [
  {
    key: 'export',
    name: '导出',
    handler: handleExport,
  },
];

const getData = useBaseAsync<JuouProTableGetDataFunction>(async(filter: JuouProTableFilter) => {
  try {
    loading.value = true;
    const dateRange = filter.conditions.dateRange as string[] | undefined;
    currentDateRange.value = dateRange || [];
    const res = await useApi().storeStatisticsApi.pageStoreStatisticsstoreStatistics({
      storeId: storeId.value,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
      start: dateRange?.[0] ? dayjs(dateRange[0]).format('YYYY-MM-DD') : undefined,
      end: dateRange?.[1] ? dayjs(dateRange[1]).format('YYYY-MM-DD') : undefined,
    });
    const tableData: JuouProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const show = (row: any) => {
  storeId.value = row.id;
  storeName.value = row.name || '';
  visible.value = true;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: `${storeName.value} - 统计详情`,
    width: "1000px",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(JuouProTable), {
        ref_key: "tableRef",
        ref: tableRef,
        title: "",
        paginations: { pageSize: 10 },
        columns: columns.value,
        "get-data": _unref(getData),
        loading: loading.value,
        "row-key": "id",
        "codition-init-values": conditionsInitValue,
        "top-operates": topOperates
      }, null, 8, ["columns", "get-data", "loading"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})